import React from 'react';

import bug from '../static/images/cute_ladybug.svg'

function Footer() {

    return (
        <div className="footer"
              style={{ marginBottom: '1rem' }}>

            <div className="bu-redline-footer">

                <div 
                    className="footer-text-div"
                    style={{ paddingTop: '1rem' }}>

                    <p 
                        className="papertrail-footer-text" 
                        style={{ float: 'left' }}>
                        Boston University College of Arts and Sciences
                    </p>

                    <img
                        className="papertrail-footer-text bug"
                        style={{ float: 'right' }}
                        alt="ladybug"
                        src={bug}
                    />

                    <p 
                        className="papertrail-footer-text" 
                        style={{ float: 'right', cursor: 'pointer' }}>
                        Report a bug
                    </p>

                </div>

            </div>
        </div>
    );
}

export default Footer;